var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content pricing"},[_c('div',{staticClass:"pricing-wrapper"},[_c('SbLoadingPromiseWrapper',{attrs:{"loadingPromise":_vm.loadingPromise,"classes":_vm.loadingWrapperClasses}},[_c('pricing-details',{staticClass:"panel"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }